<template>

    <div class="container" v-show="show">

        <div class="shadow"></div>
        <div class="share-image">

            <div class="header">
                <button @click="close" v-show="!isDesktop">
                    <img src="/img/stats/arrow-left-blue.svg" class="img__24" v-show="!isDesktop">
                </button>

                <span class="text-lSemibold" v-show="!isDesktop">{{ $t('cleaning_cards_sharing_cta') }}</span>

                <button class="img__24" @click="close">
                    <img src="/img/icons/cancel-blue.svg" class="img__24" v-show="isDesktop">
                </button>
            </div>

            <div class="body">

                <p class="text-baseRegular">{{ $t('share_stats_text') }}</p>

                <div class="bloc-shadow">
                    <div :id="statsToShare" class="bloc">

                        <div class="title">
                            <span class="text-baseMedium">{{ $t('share_with') }}</span>
                            <img class="logo" src="/img/foxy/cleanfox.svg"/>
                            <img src="/img/stats/star-blue-1.svg" class="star-1">
                            <img src="/img/stats/star-blue-2.svg" class="star-2">
                        </div>

                        <div class="info unsubscribe">
                            <div class="image">
                                <img src="/img/stats/mailbox-empty.svg">
                            </div>
                            <div class="text">
                                <span class="text-sRegular">{{ $t('share_unsubscribed_from') }}</span>
                                <span class="text-xlSemibold">{{
                                        $tc('nb_newsletters', autoDeletedNewsletters, {nb_selected: autoDeletedNewsletters})
                                    }}</span>
                            </div>
                        </div>

                        <div class="info deleted">
                            <div class="text">
                                <span class="text-sRegular">{{ $t('share_deleted') }}</span>
                                <span class="text-xlSemibold">{{
                                        $tc('cleaning_search_email_nb', deletedMails, {nb_mail: deletedMails})
                                    }}</span>
                            </div>
                            <div class="image">
                                <img src="/img/stats/trash-white.svg">
                            </div>
                        </div>

                        <div class="info saved">
                            <div class="image">
                                <img src="/img/stats/foxy-party.svg">
                            </div>
                            <div class="text">
                                <span class="text-sRegular">{{ $t('saved_on_my_mailbox') }}</span>
                                <span class="text-xlSemibold">{{ octetConverter(globalStorageSavedInKo) }}</span>
                            </div>
                        </div>

                        <div class="divider"></div>

                        <p class="text-sRegular">{{ $t('share_clean_sponsor') }}</p>

                        <div class="code">
                            <span class="text-sRegular">{{ $t('my_sponsor_code') }}</span>
                            <span class="text-xlSemibold">{{ partnerCode }}</span>
                        </div>

                    </div>
                </div>
            </div>


            <div class="bottom">

                <button :class="{'cta-small-primary': !isDesktop, 'cta-medium-primary': isDesktop}" @click="download"
                        :disabled="!partnerCode">
                    <lottie-loader :size="24" v-show="downloadImageLoading"></lottie-loader>
                    <img src="/img/icons/download-white.svg" v-show="!downloadImageLoading">
                    <span v-show="!downloadImageLoading">{{ $t('download_stats') }}</span>
                </button>

                <div class="spacer" v-show="canUseWebShareApi"></div>

                <button :class="{'cta-small-secondary': !isDesktop, 'cta-medium-secondary': isDesktop}" @click="share"
                        :disabled="!partnerCode"
                        v-show="canUseWebShareApi">
                    <lottie-loader :size="24" v-show="sharingImageLoading"></lottie-loader>
                    <img src="/img/stats/share-white.svg" class="img__20 mr__4" v-show="!sharingImageLoading">
                    <span v-show="!sharingImageLoading">{{ $t('menu_share') }}</span>
                </button>

            </div>
        </div>
        <toast ref="toast"></toast>
    </div>

</template>

<script>

import html2canvas from 'html2canvas'
import Vuex from 'vuex'

import LottieLoader from '../components/lottie/LottieLoader'
import Toast from '@/components/Toast'

export default {

    name: 'share-stats-image',

    components: {
        LottieLoader,
        Toast
    },

    computed: {

        ...Vuex.mapGetters([
            'stats',
            'user'
        ]),

        autoDeletedNewsletters() {
            return this.stats.user && this.stats.user.autoDeletedNewsletters || 0
        },

        deletedMails() {
            return this.stats.user && this.stats.user.deletedMails || 0
        },

        globalStorageSavedInKo() {
            return this.stats.user && this.stats.user.storageSavedInKo || 0
        },

        partnerCode() {
            return this.user.partnerCode
        }
    },

    data() {
        return {
            show: false,
            statsToShare: 'statsToShare',
            downloadImageLoading: false,
            sharingImageLoading: false,
            canUseWebShareApi: !!navigator.canShare
        }
    },

    methods: {

        open() {
            this.show = true
        },

        close() {
            this.show = false
        },

        async download() {
            this.downloadImageLoading = true
            const base64 = await this.blocToImage()

            if (base64) {
                const lien = document.createElement('a')
                lien.href = base64
                lien.download = 'cleanfox-stats.png'
                document.body.appendChild(lien)
                lien.click()
                document.body.removeChild(lien)
            } else {
                this.$refs.toast.open(this.$t('cleaning_list_technical_error'))
            }
            this.downloadImageLoading = false
        },

        async share() {
            this.sharingImageLoading = true
            const base64 = await this.blocToImage()
            const mimeType = 'image/png'

            const blob = await fetch(base64).then(res => res.blob())

            const fichier = new File([blob], 'image.png', {type: mimeType})

            if (navigator.canShare && navigator.canShare({files: [fichier]})) {
                try {
                    await navigator.share({
                        title: this.$t('sharing_generic_description'),
                        // text: '',
                        files: [fichier]
                    })
                } catch (err) {
                    this.$refs.toast.open(this.$t('cleaning_list_technical_error'))
                }
            }
            this.sharingImageLoading = false
        },

        blocToImage() {
            const element = document.getElementById(this.statsToShare)
            return html2canvas(element)
                .then(canvas => {

                    return canvas.toDataURL()

                })
        }
    }


}

</script>

<style lang="scss" scoped>

.container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;


    .shadow {
        @media screen and (min-width: $above-tablet-length) {
            background: rgba(0, 0, 0, 0.40);
            display: flex;
            flex: 1;
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
        }
    }

    .share-image {
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: $timberwolf;
        @media screen and (min-width: $above-tablet-length) {
            height: min-content;
            position: absolute;
            max-width: 438px;
            border-radius: 16px;
            background-color: $white;
            max-height: 100vh;
            overflow: scroll;
        }


        .header {
            padding: 16px 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            box-shadow: 0px 1px 0px 0px #D5D7DA;
            @media screen and (min-width: $above-tablet-length) {
                justify-content: flex-end;
                padding-bottom: 0;
                box-shadow: none;
            }

            button {
                background-color: $timberwolf;
                display: flex;
                align-items: center;
                justify-content: center;
                @media screen and (min-width: $above-tablet-length) {
                    background-color: $white;
                }
            }
        }

        .body {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 24px;
            overflow-y: scroll;
            @media screen and (min-width: $above-tablet-length) {
                padding-top: 16px;
            }

            .bloc-shadow {
                //the shadow is not applied to the block to avoid css copy errors when sharing
                box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08), 0px 8px 32px 0px rgba(0, 0, 0, 0.04);

                .bloc {
                    margin-top: 24px;
                    width: 100%;
                    border-radius: 24px;
                    background: $white;
                    padding: 24px 16px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;

                    .title {
                        display: flex;
                        flex-direction: row;
                        position: relative;
                        padding: 2px 0px;
                        width: min-content;

                        .logo {
                            margin: 0 4px;
                        }

                        .star-1 {
                            width: 14px;
                            object-fit: contain;
                            position: absolute;
                            bottom: -6px;
                            left: -22px;
                        }

                        .star-2 {
                            width: 18px;
                            object-fit: contain;
                            position: absolute;
                            top: -11px;
                            right: -22px;
                        }
                    }

                    .info {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 24px;
                        border-radius: 16px;
                        min-height: 100px;
                        width: 100%;
                        margin-top: 8px;

                        .text {
                            display: flex;
                            flex-direction: column;
                            text-align: start;
                            width: 50%;
                        }

                        .image {
                            height: 100%;
                            display: flex;
                            align-items: flex-end;
                            position: relative;
                            @media screen and (min-width: $above-tablet-length) {
                                flex: 1;
                                height: 100px;
                            }

                            img {
                                max-height: 90px;
                            }
                        }
                    }

                    .unsubscribe {
                        margin-top: 34px;
                        background: linear-gradient(180deg, #5EA774 0%, #79A75E 100%);
                        color: $white;

                        .text {
                            width: 60%;
                        }

                        .image {
                            img {
                                position: absolute;
                                left: -30px;
                            }
                        }
                    }

                    .deleted {
                        background: linear-gradient(155deg, #95B2D6 0%, #5FC6EC 100%);
                        color: $midnight;

                        .image {
                            justify-content: flex-end;
                        }
                    }

                    .saved {
                        background-color: $rifle;
                        color: $white;
                    }

                    .divider {
                        margin: 16px 0;
                        height: 1px;
                        width: 100%;
                        background-color: $platinum;
                    }

                    .code {
                        margin-top: 16px;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        padding: 8px 16px;
                        background-color: $blue;
                        border-radius: 16px;
                        width: 100%;
                        color: $white;
                    }
                }
            }
        }

        .bottom {
            padding: 16px;
            display: flex;
            flex-direction: row;
            align-items: center;
            background-color: $white;
            box-shadow: 0px -1px 0px 0px #D5D7DA;
            @media screen and (min-width: $above-tablet-length) {
                border-radius: 16px;
                box-shadow: none;
                padding-top: 0;
            }

            .spacer {
                width: 8px;
            }
        }
    }
}

</style>
